"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartClickPDP = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartClickPDP(productTitle) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ClickProductPicture,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            product_title: productTitle,
        },
    });
}
exports.trackCartClickPDP = trackCartClickPDP;
//# sourceMappingURL=trackCartClickPDP.js.map